'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UserProfile from 'MeetingsBase/models/UserProfile';
import { getLongDisplayName } from 'MeetingsLib/utils/utils';
import Big from 'UIComponents/elements/Big';
import H4 from 'UIComponents/elements/headings/H4';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ZeroState extends Component {
  constructor(...args) {
    super(...args);
    this.renderZeroStateText = () => {
      const {
        profile,
        linkUse
      } = this.props;
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "prebook.timeOptions.zeroState_jsx",
        options: {
          href: `mailto:${profile.email}`,
          external: true,
          use: linkUse,
          email: profile.email
        },
        elements: {
          Link: UILink
        }
      });
    };
  }
  render() {
    const {
      profile,
      TimePickerMarker
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "text-center",
      children: [/*#__PURE__*/_jsx(H4, {
        role: "alert",
        tabIndex: "1",
        "aria-level": 2,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "prebook.timeOptions.sorry",
          options: {
            fullName: getLongDisplayName(profile)
          }
        })
      }), /*#__PURE__*/_jsx(Big, {
        children: this.renderZeroStateText()
      }), /*#__PURE__*/_jsx(TimePickerMarker, {})]
    });
  }
}
ZeroState.propTypes = {
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  linkUse: PropTypes.string,
  TimePickerMarker: PropTypes.func.isRequired
};